import config from 'config/config';

const urls = {
    // WIZ-SSO API - 인증
    "ssoLogin": "/wizsso/api/v2/auth/login",
    "ssoSocialLogin": "/wizsso/api/v2/auth/social",
    "ssoSignup": "/wizsso/api/v2/auth/signup",
    "ssoRefresh": "/wizsso/api/v2/auth/refresh",
    "ssoRevoke": "/wizsso/api/v2/auth/revoke",
    "ssoUser": "/wizsso/api/v2/auth/user",
    "ssoUpdateProfile": "/wizsso/api/v2/auth/user",
    "ssoProfileImage": "/wizsso/api/v2/profile/image",
    "ssoProfileNickname": "/wizsso/api/v2/profile/nickname",
    "ssoProfileStatusMsg": "/wizsso/api/v2/profile/status-msg",
    "ssoWithdraw": "/wizsso/api/v2/auth/user",

    // DOKOCREW API - 모임 관리
    "meetings": "/dokocrew/api/v1/meetings",
    "meetingDetail": "/dokocrew/api/v1/meetings",
    "meetingMembers": "/dokocrew/api/v1/meetings",
    "meetingInvite": "/dokocrew/api/v1/meetings",
    "meetingJoin": "/dokocrew/api/v1/meetings",
    "meetingLeave": "/dokocrew/api/v1/meetings",
    "meetingPosts": "/dokocrew/api/v1/meeting-posts",

    // DOKOCREW API - 일정 관리
    "schedules": "/dokocrew/api/v1/meetings",
    "scheduleVote": "/dokocrew/api/v1/schedules",
    "scheduleConfirm": "/dokocrew/api/v1/schedules",
    "scheduleAiRecommend": "/dokocrew/api/v1/meetings",
    "scheduleProposals": "/dokocrew/api/v1/schedule-proposals",
    "scheduleStatistics": "/dokocrew/api/v1/meetings",
    "scheduleProposalVote": "/dokocrew/api/v1/schedule-proposals",
    "scheduleConfirmFromProposal": "/dokocrew/api/v1/schedules",

    // DOKOCREW API - 정산 관리
    "payments": "/dokocrew/api/v1/meetings",
    "paymentDetail": "/dokocrew/api/v1/payments",
    "paymentRequest": "/dokocrew/api/v1/payments",
    "paymentComplete": "/dokocrew/api/v1/payments",
    "receiptOcr": "/dokocrew/api/v1/meetings",

    // DOKOCREW API - 채팅
    "chatMessages": "/dokocrew/api/v1/chats/meetings",
    "chatRead": "/dokocrew/api/v1/chats",

    // WIZ-CHAT API - 사용자 차단
    "chatBlocks": "/wizchat/api/chat/blocks",
    // WIZ-CHAT API - 사용자 신고
    "chatReports": "/wizchat/api/chat/reports",
    // WIZ-CHAT API - 채팅방 목록 (인앱 알림 배너용 — 사용자가 속한 모든 room 구독)
    "chatRoomList": "/wizchat/api/chat/rooms",

    // DOKOCREW API - 서브 장소
    "subPlaces": "/dokocrew/api/v1/meetings",

    // DOKOCREW API - 알림 설정
    "notificationSettings": "/dokocrew/api/v1/notification-settings",

    // DOKOCREW API - 여행지 추천 (OpenTripMap 캐시)
    "travelPlaces": "/dokocrew/api/v1/travel/places",
    "travelSearch": "/dokocrew/api/v1/travel/search",
    "travelCities": "/dokocrew/api/v1/travel/cities",
    "nearbyPlaces": "/dokocrew/api/v1/travel/nearby",
    "placePhotos": "/dokocrew/api/v1/travel/photos",
    "placeInfo": "/dokocrew/api/v1/travel/place-info",
    "travelReviews": "/dokocrew/api/v1/travel/reviews",

    // DOKOCREW API - 장소 리뷰/사진 (UGC)
    "placeReviews": "/dokocrew/api/v1/places",
    "travelCourses": "/dokocrew/api/v1/travel/courses",

    // DOKOCREW API - 급번개 (Flash Meetup)
    "flash": "/dokocrew/api/v1/flash",

    // DOKOCREW API - 귀가 도우미 (Safe Return)
    "safeReturn": "/dokocrew/api/v1/safe-return",
    "userHome": "/dokocrew/api/v1/users/me/home",

    // DOKOCREW API - 내 위치 확인 이력 통계 (설정 화면용)
    "myLocationViewStats": "/dokocrew/api/v1/me/location-view-stats",

    // WIZ-LBS API - 위치 조회
    "lbsLatestLocation": "/lbs-service/api/v2/location/path/latest",

    // WIZ-SSO API - 푸시 동의 (tb_user_msg_consent)
    "ssoPushConsent": "/wizsso/api/v2/user/msg-consent",

    // WIZ-MESSAGE API - 푸시 발송
    "wizMessagePush": "/wizmessage/api/v1/push/send",

    // WIZ-MESSAGE API - 푸시 이력 조회 (내 알림 목록)
    "wizMessagePushHist": "/wizmessage/api/v2/push/hist",

    // WIZ-COMMON API - 파일 업로드
    "fileUpload": "/wizcommon/api/v2/file/upload",

    // WIZ-AI API - 영수증 OCR (PaddleOCR) — Gateway 경유 (사용자 JWT 로 통과)
    "wizaiReceiptAnalyze": "/wizai/api/v1/receipt/analyze",

    // WIZ-COMMON API - 공지사항
    "notices": "/wizcommon/api/v2/notice",
    "noticeDetail": "/wizcommon/api/v2/notice",

    // WIZ-COMMON API - FAQ
    "faqs": "/wizcommon/api/v2/faq",

    // WIZ-COMMON API - QNA/의견보내기
    "qnas": "/wizcommon/api/v2/qna",
    "qnaDetail": "/wizcommon/api/v2/qna",
    "qnaSend": "/wizcommon/api/v2/qna/send",

    // WIZ-COMMON API - 약관
    "terms": "/wizcommon/api/v2/terms",
    "termsDetail": "/wizcommon/api/v2/terms",
    "termsByType": "/wizcommon/api/v2/terms/type",

    // WIZ-COMMON API - 앱 팝업 (사용팁 등)
    "appPopupActive": "/wizcommon/api/v2/app-popup/active",
    "appPopupAction": "/wizcommon/api/v2/app-popup",
}

export const getApiUrl = (name: keyof typeof urls) => {
    return config.API_URL + urls[name];
}

export const getEnv = () => config.NODE_ENV;
export const isDebug = () => config.NODE_ENV !== 'prod';
export const getGatewayUrl = () => config.API_URL;
export const getSsoUrl = () => config.SSO_URL;
export const getServiceId = () => config.SERVICE_ID;
export const getClientId = () => config.CLIENT_ID;
